import { toUseStartClass, toUseStartLiveClass, toUseCreateAkamaiStream } from '@engage/data-fetch-v2/domain';
import { StreamFetchers, PelotonFetchers, WorkoutsFetchers } from './fetchers';
import { engageApi } from './singletons';
export var useStartClass = toUseStartClass(PelotonFetchers, WorkoutsFetchers);
export var useStartLiveClass = toUseStartLiveClass(WorkoutsFetchers);
export var useCreateAkamaiStream = toUseCreateAkamaiStream(StreamFetchers, engageApi);